/* ───── Render Table Helper ───── */

import { formatDateTime } from "../../utils/dateTime";

export const renderTable = (title, count, entries, showScore = false) => (
  <div className="w-fit flex flex-col border border-greyscale-1 rounded-lg overflow-hidden">
    <div
      className={`w-full grid ${
        showScore ? "grid-cols-4" : "grid-cols-3"
      } gap-1 patient-list-container font-medium bg-greyscale-0.5`}
    >
      <div className="flex items-center"></div>
      <div className="flex items-center justify-center">Date </div>
      <div className="flex items-center justify-center">Time </div>
      {/* Optional Score Column Header */}
      {showScore && (
        <div className="flex items-center justify-center">Score </div>
      )}
    </div>

    <div className="w-fit max-h-[80dvh] overflow-y-auto">
      {entries?.length ? (
        entries.map((item, i) => {
          const { date, time } = formatDateTime(item.takenAt);
          return (
            <div
              key={item.name + i}
              className={`w-fit grid ${
                showScore ? "grid-cols-4" : "grid-cols-3"
              } gap-1 patient-list-container hover:bg-greyscale-0.5 transition-colors`}
            >
              <div className="flex items-center">{i + 1}</div>
              <div className="flex items-center justify-center">{date}</div>
              <div className="flex items-center justify-center">{time}</div>
              {/* Optional Score Column Value */}
              {showScore && (
                <div className="flex items-center justify-center font-medium text-primary">
                  {item.score ?? "-"}
                </div>
              )}
            </div>
          );
        })
      ) : (
        <div className="patient-list-container text-center text-greyscale-3">
          No Entries{" "}
        </div>
      )}
    </div>
  </div>
);
